var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoundationGraphPie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 92,
    viewBox: "0 0 157 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.083 11.8405C83.9353 11.8405 83.0028 12.3869 83.0028 13.0604C83.0028 13.1229 83.0483 13.1772 83.064 13.2379H83.0028V42.1609C83.0028 42.8343 83.9353 43.3808 85.083 43.3808H134.439V43.3449C134.543 43.3541 134.635 43.3808 134.744 43.3808C135.891 43.3808 136.824 42.8343 136.824 42.1609C136.529 25.4905 113.531 12.0143 85.083 11.8405Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.791 49.1832C124.791 48.5098 123.86 47.9633 122.711 47.9633H77.3398C76.7879 47.963 76.2588 47.8344 75.8687 47.6057C75.4786 47.3769 75.2595 47.0667 75.2595 46.7434V20.2538H75.1983C75.214 20.1931 75.2595 20.1388 75.2595 20.0762C75.2595 19.4019 74.3269 18.8563 73.1777 18.8563C73.1275 18.8563 73.0866 18.871 73.038 18.8729V18.8646C72.8527 18.8637 72.669 18.8563 72.4837 18.8563C43.5957 18.8563 20.1761 32.58 20.1761 49.508C20.1761 66.436 43.5957 80.1596 72.4837 80.1596C101.372 80.1596 124.791 66.436 124.791 49.508C124.791 49.4104 124.784 49.3138 124.78 49.2154C124.78 49.2034 124.791 49.1942 124.791 49.1832Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundationGraphPie);
export default __webpack_public_path__ + "static/media/foundation_graph-pie.cef8470a83d265846b37491354ce06a8.svg";
export { ForwardRef as ReactComponent };